<template>
  <div class="auth-wrapper d-flex no-block justify-content-center align-items-center">
    <router-link to="/" class="auth-back-link">
      <i class="ti-back-left"></i>
      {{ $t('legal.back_home') }}
    </router-link>
    <LocaleSwitcher floating />
    <div class="auth-box">
      <div class="logo">
        <router-link to="/" class="db d-inline-block">
          <img src="/logo-banner.png" class="auth-logo mb-3" alt="SocialLabs" />
        </router-link>
        <p>{{ $t('auth.register_as') }} <span class="text-primary">{{ $t('global.admin') }}</span></p>
      </div>
      <form class="form-horizontal m-t-20" @submit.prevent="handleSubmit">
        <div class="input-group mb-3">
          <div class="input-group-prepend"><span class="input-group-text"><i class="ti-user"></i></span></div>
          <input v-model.trim="form.name" type="text" class="form-control form-control-lg" :placeholder="$t('global.name') + '*'" required>
        </div>
        <div class="input-group mb-3">
          <div class="input-group-prepend"><span class="input-group-text"><i class="ti-email"></i></span></div>
          <input v-model.trim="form.email" type="email" class="form-control form-control-lg" :placeholder="$t('global.email') + '*'" required>
        </div>
        <div class="input-group mb-3">
          <div class="input-group-prepend"><span class="input-group-text"><i class="ti-pencil"></i></span></div>
          <input v-model="form.password" type="password" class="form-control form-control-lg" :placeholder="$t('auth.password') + '*'" required>
        </div>
        <p class="auth-legal-note text-center small text-muted mb-3">
          {{ $t('auth.register_terms_prefix') }}
          <router-link to="/terms">{{ $t('legal.terms') }}</router-link>
          {{ $t('auth.register_terms_and') }}
          <router-link to="/privacy">{{ $t('legal.privacy') }}</router-link>.
        </p>
        <div class="form-group text-center">
          <button class="btn btn-block btn-lg btn-primary" :disabled="isLoading">
            <span v-if="isLoading" class="spinner-border spinner" role="status"></span>
            <span>{{ isLoading ? $t('auth.loading') : $t('auth.register') }}</span>
          </button>
        </div>
        <div class="form-group text-center">
          {{ $t('auth.already_have_account') }}
          <router-link to="/login" class="color-primary">{{ $t('auth.sign_in_now') }}</router-link>
        </div>
        <GoogleSignInButton redirect="/dashboard" :disabled="isLoading" />
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import LocaleSwitcher from '@/components/LocaleSwitcher.vue'
import GoogleSignInButton from '@/components/auth/GoogleSignInButton.vue'

export default {
  components: { LocaleSwitcher, GoogleSignInButton },
  data() {
    return {
      form: { name: '', email: '', password: '', phone: '' },
      isLoading: false,
    }
  },
  methods: {
    ...mapActions('auth', ['register']),
    async handleSubmit() {
      this.isLoading = true
      try {
        await this.register(this.form)
        this.$toast.success(this.$t('auth.register_success'))
        await this.$router.push('/login')
      } catch (error) {
        this.$toast.error(error.response?.data?.message || this.$t('auth.register_failed'))
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style scoped>
.spinner { height: 1rem !important; width: 1rem !important; }
</style>
